/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InitPaymentInput } from '../models/InitPaymentInput';
import type { InitPaymentResult } from '../models/InitPaymentResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PaymentService {

    /**
     * @param version 
     * @param packageId 
     * @param requestBody 
     * @returns InitPaymentResult OK
     * @throws ApiError
     */
    public static initNovinPayment(
version: string,
packageId?: number,
requestBody?: InitPaymentInput,
): CancelablePromise<InitPaymentResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Payment/Novin/Init',
            path: {
                'version': version,
            },
            query: {
                'packageId': packageId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param formData 
     * @returns any OK
     * @throws ApiError
     */
    public static verifyNovinPayment(
version: string,
formData?: {
RefNum?: string;
ResNum?: string;
Token?: string;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Payment/Novin/Verify',
            path: {
                'version': version,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

    /**
     * @param version 
     * @param packageId 
     * @param requestBody 
     * @returns InitPaymentResult OK
     * @throws ApiError
     */
    public static initSayanPayment(
version: string,
packageId?: number,
requestBody?: InitPaymentInput,
): CancelablePromise<InitPaymentResult> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Payment/Sayan/Init',
            path: {
                'version': version,
            },
            query: {
                'packageId': packageId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param version 
     * @param formData 
     * @returns any OK
     * @throws ApiError
     */
    public static verifySayanPayment(
version: string,
formData?: {
RefNum?: string;
ResNum?: string;
Token?: string;
},
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Payment/Sayan/Verify',
            path: {
                'version': version,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
